/**
 * @generated SignedSource<<1494ffe347193a6b107a400d25bdad37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgLogoutButton_me$data = {
  readonly email: string;
  readonly name: string;
  readonly " $fragmentType": "OrgLogoutButton_me";
};
export type OrgLogoutButton_me$key = {
  readonly " $data"?: OrgLogoutButton_me$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgLogoutButton_me">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgLogoutButton_me",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "dc9c39b948002327028b126771543452";

export default node;
